import { useState } from 'react';
import { Col, Container, Modal, ModalBody, Row } from 'react-bootstrap';
import Button from '../../../components/Button/Button';
import ModalHeader from '../../../components/ModalHeader';
import Pager from '../../../components/Pager';

const PaymentHistoryModal = ({
  showModal = false,
  handleClose,
  paymentHistoryData,
  ...props
}: any) => {
  const [currPage, setCurrPage] = useState(1);

  return (
    <Modal show={showModal} onHide={handleClose} {...props} size="xl">
      <ModalHeader closeButton className="pb-0">
        <h4>Payment History</h4>
      </ModalHeader>
      <ModalBody className="pt-0">
        <Container>
          <Row className={'m-0 mt-10 py-3 border-bottom-dark-gray'}>
            <Col className={'col-3'}>
              <span className={'text-fs-6 fw-normal'}>Statement/Receipt</span>
            </Col>
            <Col className={'col-3'}>
              <span className={'text-fs-6 fw-normal'}>Coverage Dates</span>
            </Col>
            <Col className={'col-2 text-end'}>
              <span className={'text-fs-6 fw-normal'}>Amount Due</span>
            </Col>
            <Col className={'col-2 px-0 text-end'}>
              <span className={'text-fs-6 fw-normal'}>Payment Received</span>
            </Col>
            <Col className={'col-2 text-end'}>
              <span className={'text-fs-6 fw-normal'}>Method</span>
            </Col>
          </Row>
          <Row className="m-0">
            <Col className={'col-12 overflow-auto'}>
              <Row
                className={'overflow-hidden'}
                style={{
                  minWidth: '650px',
                }}
              >
                <Col>
                  {paymentHistoryData.map((history: any, idx: number) => {
                    return (
                      <Row
                        className={`py-3 ${
                          idx !== history.length - 1
                            ? 'border-bottom-light-gray-lg'
                            : ''
                        }`}
                      >
                        <Col className={'col-3'}>
                          <span className={'text-fs-6 fw-light text-blue'}>
                            {history.statement}
                          </span>
                        </Col>
                        <Col className={'col-3'}>
                          <span className={'text-fs-6 fw-light'}>
                            {history.coverageDates}
                          </span>
                        </Col>
                        <Col className={'col-2 text-end'}>
                          <span className={'text-fs-6 fw-light'}>
                            {history.amoutDue}
                          </span>
                        </Col>
                        <Col className={'col-2 px-0 text-end'}>
                          <span className={'text-fs-6 fw-light'}>
                            {history.paymentReceived}
                          </span>
                        </Col>
                        <Col className={'col-2 text-end'}>
                          <span className={'text-fs-6 fw-light'}>
                            {history.method}
                          </span>
                        </Col>
                      </Row>
                    );
                  })}
                </Col>
              </Row>
            </Col>
          </Row>
          <Container
            className={
              'px-0 mt-11 d-flex d-lg-block justify-content-center mt-11 mt-lg-10'
            }
          >
            <Pager
              pagesSize={3}
              currentPage={currPage}
              onPageChange={setCurrPage}
            />
          </Container>
          <Row className="justify-content-center mt-10 mb-10">
            <Col className={'col-3 col-lg-2'}>
              <Button
                variant="primary-outline"
                className={'w-100'}
                onClick={handleClose}
              >
                Close
              </Button>
            </Col>
          </Row>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default PaymentHistoryModal;
